import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import useMap from '@alltrails/maps/hooks/useMap';
import {
  communityHeatmapId,
  communityHeatmapLayerPaintProps,
  communityHeatmapLayerWithSatellitePaintProps,
  getLayerBeforeId
} from '@alltrails/maps/utils/layers';
import { useAppSelector } from '../../redux/helpers';

// https://www.figma.com/design/vDdcMEqjmNXfQV7vvTtocS/Heatmaps-%5BHandoff%5D?node-id=1277-258156&m=dev

const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

const sourceId = 'heatmap-raster-tiles';

const CommunityHeatmap = () => {
  const map = useMap();
  const dynamicStyleIds = useAppSelector(state => state.map.dynamicStyleIds);
  const { baseStyleId, urlTemplate, currentlySelectedOptions } = useAppSelector(state => ({
    baseStyleId: state.map.baseStyleId,
    urlTemplate: state.heatmaps.urlTemplate,
    currentlySelectedOptions: state.heatmaps.currentlySelectedOptions
  }));

  const finalUrl = useMemo(() => {
    if (!urlTemplate || !currentlySelectedOptions) {
      return `/wmts/static/heatmaps/years_1/all/{z}/{x}/{y}.png?key=${apiKey}`;
    }

    let url = urlTemplate;
    Object.entries(currentlySelectedOptions).forEach(([key, option]) => {
      if (option?.value) {
        url = url.replace(`{{${key}}}`, option.value);
      }
    });
    return `${url}?key=${apiKey}`;
  }, [urlTemplate, currentlySelectedOptions]);

  if (!dynamicStyleIds.includes('newHeatmap')) {
    return null;
  }

  return baseStyleId === 'alltrailsSatellite' || baseStyleId === 'googleSatellite' ? (
    <Source key={finalUrl} id={sourceId} type="raster" tiles={[finalUrl]} tileSize={512} attribution="© AllTrails" minzoom={0} maxzoom={16}>
      <Layer
        id={communityHeatmapId}
        beforeId={getLayerBeforeId(map, communityHeatmapId)}
        type="raster"
        source={sourceId}
        paint={communityHeatmapLayerWithSatellitePaintProps}
        minzoom={0}
        maxzoom={22}
      />
    </Source>
  ) : (
    <Source key={finalUrl} id={sourceId} type="raster" tiles={[finalUrl]} tileSize={512} attribution="© AllTrails" minzoom={0} maxzoom={16}>
      <Layer
        id={communityHeatmapId}
        beforeId={getLayerBeforeId(map, communityHeatmapId)}
        type="raster"
        source={sourceId}
        paint={communityHeatmapLayerPaintProps}
        minzoom={0}
        maxzoom={22}
      />
    </Source>
  );
};

export default CommunityHeatmap;
